<script setup lang="ts">
import type { Question } from "~/features/python/ch2/exercise/types/exercise.types";

defineProps<{
  question: Question;
  hasSubmitted: boolean;
  isCorrect: boolean | null;
}>();
</script>

<template>
  <section class="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">Asaan samjhayi</h2>
      <p class="text-sm text-slate-600">Yahan simple alfaaz me bataya gaya hai ke jawab aisa kyun hai.</p>
    </div>

    <div
      v-if="hasSubmitted && isCorrect !== null"
      class="mt-4 rounded-2xl p-4"
      :class="isCorrect ? 'bg-emerald-50 ring-1 ring-emerald-200' : 'bg-rose-50 ring-1 ring-rose-200'"
    >
      <p class="text-sm font-semibold" :class="isCorrect ? 'text-emerald-700' : 'text-rose-700'">
        {{ isCorrect ? "Bilkul sahi" : "Abhi sahi nahi" }}
      </p>
      <p class="mt-1 text-sm text-slate-700">{{ question.explanation }}</p>
    </div>

    <div v-else class="mt-4 rounded-2xl bg-slate-50 p-4 ring-1 ring-slate-200">
      <p class="text-sm text-slate-700">{{ question.explanation }}</p>
    </div>
  </section>
</template>
